import AdvertisementDetails from './AdvertisementDetails'

export default AdvertisementDetails
